import { render, staticRenderFns } from "./FiltroDirigentes.vue?vue&type=template&id=4d62c4fe"
import script from "./FiltroDirigentes.vue?vue&type=script&lang=js"
export * from "./FiltroDirigentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports